// Bilingual content for the Scopelink.io landing page.
// Edit copy / pricing / features here.

export const CONTACT_URL =
  "https://astro.scopelink.io/procyon/campaigns/contact/";

export const CONTACT_EMAIL = "info@scopelink.io";

export const APP_URL = "https://astro.scopelink.io";

export const content = {
  ES: {
    nav: {
      platform: "Plataforma",
      plans: "Planes",
      news: "Novedades",
      contact: "Contacto",
      appAccess: "Registro / Login",
    },
    hero: {
      kicker: "PLATAFORMA IoT · ASTRONOMÍA REMOTA",
      title1: "TU OBSERVATORIO",
      title2: "SEGURO Y CONECTADO",
      subtitle:
        "Controla, monitoriza y comparte tu observatorio remoto sin entregar nunca tus credenciales. Infraestructura de grado astronómico para clubes, instituciones y astrofotógrafos.",
      ctaPrimary: "Contactar",
      ctaSecondary: "Ver planes",
      tickers: [
        "ACCESO MULTIUSUARIO",
        "INTEGRACIÓN IoT",
        "MONITORIZACIÓN CLOUD",
        "VPN ZERO-TRUST",
        "ESTACIONES METEO",
        "ESCRITORIO REMOTO",
        "CÁMARAS IP",
        "SAFETY MONITOR",
      ],
      stats: [
        { value: "24/7", label: "Uptime objetivo" },
        { value: "0", label: "Credenciales compartidas" },
        { value: "∞", label: "Dispositivos IoT" },
      ],
    },
    platform: {
      kicker: "// SISTEMA CORE",
      title: "UN PANEL DE GESTIÓN",
      titleAccent: "PARA TU OBSERVATORIO",
      lead:
        "Una plataforma integral que unifica el acceso seguro multiusuario, cámaras, estaciones meteorológicas y detectores cloud. Diseñada para observatorios remotos, asociaciones y grandes instalaciones científicas.",
      body:
        "Scopelink.io transforma la manera de compartir un observatorio: cada usuario opera con su propia identidad, sin contraseñas comunes y con permisos granulares. Toda la información — meteorología, cielo, cámaras y resto de dispositivos integrados — se concentra en un único cuadro de mando, accesible desde la red local o desde la nube.",
      publicCta: "Ver observatorios con perfil público",
      features: [
        { icon: "Shield", title: "Seguridad Zero-Trust", desc: "VPN cifrada y permisos por usuario. Cero contraseñas compartidas." },
        { icon: "Cpu", title: "Integración IoT", desc: "Estaciones meteo, cámaras, sensores de cielo, UPS, relés inteligentes y más." },
        { icon: "Cloud", title: "Acceso Cloud", desc: "Operación desde la red local o desde cualquier lugar del mundo." },
        { icon: "Users", title: "Multiusuario Real", desc: "Cada miembro con su sesión, su agenda y su huella de auditoría." },
        { icon: "CloudRain", title: "Datos Meteo", desc: "Detectores de nubes, lluvia, viento, humedad y seeing." },
        { icon: "Video", title: "Cámaras IP", desc: "Vistas en vivo del domo y del cielo, con grabación opcional." },
      ],
    },
    about: {
      kicker: "// SOBRE NOSOTROS",
      title: "SOBRE",
      titleAccent: "NOSOTROS",
      lead:
        "Scopelink nació con una idea muy sencilla: gestionar un observatorio remoto debería ser tan fácil como utilizarlo.",
      body:
        "Desarrollamos software para propietarios de observatorios, asociaciones astronómicas, universidades y empresas de observatory hosting que necesitan acceso remoto seguro, automatización fiable y una gestión centralizada.",
      story: [
        "Nuestra plataforma reúne usuarios, dispositivos y observatorios en un único lugar, facilitando el uso compartido de equipos, la gestión de permisos y la supervisión de toda la instalación desde cualquier lugar.",
        "Scopelink está respaldado por más de 25 años de experiencia en desarrollo de software y una amplia experiencia en el diseño y la gestión de infraestructuras críticas, donde la fiabilidad, la seguridad y la trazabilidad no son opcionales, sino requisitos fundamentales. Esa forma de trabajar es la base sobre la que construimos nuestra plataforma.",
        "A diferencia de las soluciones genéricas de acceso remoto, Scopelink ha sido diseñado específicamente para la astronomía. Se integra con el hardware y el software habituales en un observatorio, reduciendo la complejidad para los propietarios y ofreciendo una experiencia sencilla para los usuarios.",
        "Nuestro objetivo es ayudar a que los observatorios remotos sean más fáciles de operar, compartir y hacer crecer.",
      ],
      publicCta: "Ver observatorios con perfil público",
      backHome: "Volver al inicio",
      backSection: "Ver sección resumen",
      features: [
        { icon: "Shield", title: "Seguridad Zero-Trust", desc: "VPN cifrada y permisos por usuario. Cero contraseñas compartidas." },
        { icon: "Cpu", title: "Integración IoT", desc: "Estaciones meteo, cámaras, sensores de cielo, UPS, relés inteligentes y más." },
        { icon: "Cloud", title: "Acceso Cloud", desc: "Operación desde la red local o desde cualquier lugar del mundo." },
        { icon: "Users", title: "Multiusuario Real", desc: "Cada miembro con su sesión, su agenda y su huella de auditoría." },
        { icon: "CloudRain", title: "Datos Meteo", desc: "Detectores de nubes, lluvia, viento, humedad y seeing." },
        { icon: "Video", title: "Cámaras IP", desc: "Vistas en vivo del domo y del cielo, con grabación opcional." },
      ],
    },
    plans: {
      kicker: "// SUSCRIPCIONES",
      title: "UN PLAN PARA",
      titleAccent: "CADA OBSERVATORIO",
      subtitle:
        "Selecciona la capacidad de tu estación. Aplican descuentos por volumen para clubes y asociaciones.",
      billing: "facturado anualmente",
      perUser: "/ mes por usuario",
      contact: "Contactar",
      mostPopular: "RECOMENDADO",
      tiers: [
        {
          id: "albireo",
          code: "// 01",
          name: "Albireo",
          price: "5,99 €",
          period: "/ mes · por usuario",
          billing: "Facturado anualmente",
          tagline: "Para iniciarte en el remoto",
          features: [
            "Conexión VPN segura",
            "Acceso a imagen de 1 cámara",
            "Datos de 1 estación meteo",
            "Máx. 2 usuarios",
          ],
          popular: false,
        },
        {
          id: "beehive",
          code: "// 02",
          name: "Beehive",
          price: "8,99 €",
          period: "/ mes · por usuario",
          billing: "Facturado anualmente",
          tagline: "Para observatorios activos",
          features: [
            "Conexión VPN segura",
            "Acceso a imagen de 2 cámaras",
            "Datos de 2 dispositivos meteo",
            "Safety monitor",
          ],
          popular: false,
        },
        {
          id: "hercules",
          code: "// 03",
          name: "Pleiades",
          price: "11,99 €",
          period: "/ mes · por usuario",
          billing: "Facturado anualmente",
          tagline: "Para producción nocturna",
          features: [
            "Conexión VPN segura",
            "Escritorio remoto compartido",
            "4 cámaras IP",
            "Datos de 3 dispositivos meteo",
            "Safety monitor",
            "Auditoría de datos",
          ],
          popular: true,
        },
        {
          id: "pleiades",
          code: "// 04",
          name: "Hercules",
          price: "59 €",
          period: "/ mes · plan completo",
          billing: "Facturado anualmente",
          tagline: "Para compartir el observatorio con tu comunidad",
          features: [
            "3 operadores con control total",
            "Hasta 50 usuarios viewer",
            "Sesiones de observación ad-hoc",
            "Panel del observatorio + cámaras en vivo",
            "Datos meteo y ambientales",
            "Control de dispositivos (operadores)",
            "Registro de auditoría",
          ],
          limitations: [
            "Sin VPN ni escritorio remoto para usuarios viewer",
          ],
          addon: "+ 1 TB de almacenamiento compartido · 20 €/mes",
          contactNote: "¿Necesitas más usuarios? Escríbenos.",
          ctaOverride: "Empezar",
          popular: false,
        },
        {
          id: "virgo",
          code: "// 05",
          name: "Virgo Cluster",
          price: "Custom",
          period: "Contactar para precio",
          billing: "Multi-observatorio",
          tagline: "Para redes e instituciones",
          features: [
            "Multi-observatorio",
            "Gestión de agenda para alquiler",
            "Securización de webs autoalojadas",
            "Dispositivos compartidos entre sedes",
            "Pagos online para usuarios",
            "Y mucho más…",
          ],
          popular: false,
        },
      ],
      discountNote:
        "Aplican descuentos por volumen. Escríbenos a info@scopelink.io para clubes, asociaciones y grandes instalaciones.",
    },
    cta: {
      kicker: "// SIGUIENTE PASO",
      title: "ABRE TU CÚPULA",
      titleAccent: "DESDE CUALQUIER LUGAR",
      body:
        "Cuéntanos cómo es tu observatorio y diseñamos contigo la configuración exacta — cámaras, meteorología, accesos y agenda.",
      ctaPrimary: "Hablar con un ingeniero",
    },
    news: {
      kicker: "// LOG · DIARIO DE A BORDO",
      title: "ÚLTIMAS",
      titleAccent: "NOVEDADES",
      subtitle:
        "Casos de estudio, lanzamientos de la plataforma y guías técnicas para observatorios remotos.",
      readMore: "Leer artículo",
      viewAll: "Ver todas las entradas",
      items: [
        {
          id: "n04",
          category: "Experiencia",
          date: "2026-07-27",
          dateLabel: "27 JUL · 2026",
          readTime: "4 min",
          title: "Así se siente operar un observatorio real con Scopelink",
          excerpt:
            "Un vistazo a una sesión real desde El Hierro: controla tu telescopio bajo uno de los cielos más oscuros del mundo.",
          image: "https://img.youtube.com/vi/-wLhxg4us4s/hqdefault.jpg",
          imageSrcSet: "https://img.youtube.com/vi/-wLhxg4us4s/hqdefault.jpg 480w, https://img.youtube.com/vi/-wLhxg4us4s/maxresdefault.jpg 1280w",
          href: "/articles/scopelink-experience-el-hierro",
        },
        {
          id: "n01",
          category: "Lanzamiento",
          date: "2026-05-20",
          dateLabel: "20 MAY · 2026",
          readTime: "5 min",
          title: "Virgo Cluster: gestión de varios observatorios desde un único panel",
          excerpt:
            "Presentamos el plan multi-observatorio: agenda compartida, dispositivos federados y pagos online para asociaciones y redes de telescopios.",
          image:
            "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=640&q=75",
          imageSrcSet:
            "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=360&q=70 360w, https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=640&q=75 640w, https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=960&q=75 960w",
          href: "/articles/virgo-cluster",
        },
        {
          id: "n02",
          category: "Seguridad",
          date: "2026-04-08",
          dateLabel: "08 APR · 2026",
          readTime: "7 min",
          title: "Privileged Access Management (PAM) para observatorios remotos",
          excerpt:
            "Por qué los observatorios remotos están dejando atrás las contraseñas compartidas y adoptando accesos privilegiados, temporales y auditables.",
          image:
            "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=640&q=75",
          imageSrcSet:
            "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=360&q=70 360w, https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=640&q=75 640w, https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=960&q=75 960w",
          href: "/articles/pam",
        },
        {
          id: "n03",
          category: "Plataforma",
          date: "2026-06-14",
          dateLabel: "14 JUN · 2026",
          readTime: "6 min",
          title: "Integrando el ecosistema del observatorio",
          excerpt:
            "Telescopios, cámaras, monturas, meteo, UPS, sensores de cielo, Shelly… cómo Scopelink unifica todo el observatorio bajo una misma capa de gestión.",
          image:
            "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=640&q=75",
          imageSrcSet:
            "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=360&q=70 360w, https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=640&q=75 640w, https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=960&q=75 960w",
          href: "/articles/ecosystem",
        },
      ],
    },
    footer: {
      tag: "Tu plataforma IoT para gestión integral de observatorios astronómicos remotos.",
      colQuick: "Enlaces rápidos",
      quickLinks: [
        { label: "Sobre nosotros", href: "https://www.scopelink.io/sobre-nosotros/" },
        { label: "Servicios IoT", href: "https://www.scopelink.io/servicios-iot/" },
        { label: "Contacto", href: CONTACT_URL },
      ],
      colLegal: "Legal",
      legalLinks: [
        { label: "Política de privacidad", href: "/politica-de-privacidad" },
        { label: "Política de cookies", href: "/politica-de-cookies" },
      ],
      colContact: "Contacto",
      rights: "© 2026 Scopelink.io · Todos los derechos reservados.",
    },
  },

  EN: {
    nav: {
      platform: "Platform",
      plans: "Plans",
      news: "News",
      contact: "Contact",
      appAccess: "Register / Login",
    },
    hero: {
      kicker: "IoT PLATFORM · REMOTE ASTRONOMY",
      title1: "YOUR OBSERVATORY",
      title2: "SECURE & CONNECTED",
      subtitle:
        "Operate, monitor and share your remote observatory without ever handing out credentials. Astronomical-grade infrastructure for clubs, institutions and astrophotographers.",
      ctaPrimary: "Contact us",
      ctaSecondary: "See plans",
      tickers: [
        "MULTI-USER ACCESS",
        "IoT INTEGRATION",
        "CLOUD MONITORING",
        "ZERO-TRUST VPN",
        "WEATHER STATIONS",
        "REMOTE DESKTOP",
        "IP CAMERAS",
        "SAFETY MONITOR",
      ],
      stats: [
        { value: "24/7", label: "Target uptime" },
        { value: "0", label: "Shared credentials" },
        { value: "∞", label: "IoT devices" },
      ],
    },
    platform: {
      kicker: "// CORE SYSTEM",
      title: "A MANAGEMENT PANEL",
      titleAccent: "FOR YOUR OBSERVATORY",
      lead:
        "An end-to-end platform unifying secure multi-user access, cameras, weather stations, and cloud detectors. Built for remote observatories, associations, and large scientific facilities.",
      body:
        "Scopelink.io transforms the way an observatory is shared: every user operates with their own identity, without shared passwords and with granular permissions. All information — weather, sky conditions, cameras, and the rest of the integrated devices — is concentrated in a single dashboard, accessible from the local network or from the cloud.",
      publicCta: "Check out observatories with a public profile",
      features: [
        { icon: "Shield", title: "Zero-Trust Security", desc: "Encrypted VPN with per-user permissions. Zero shared passwords." },
        { icon: "Cpu", title: "IoT Integration", desc: "Weather stations, cameras, sky sensors, UPS, smart relays and more." },
        { icon: "Cloud", title: "Cloud Access", desc: "Operate from your local network or from anywhere on the planet." },
        { icon: "Users", title: "True Multi-user", desc: "Every member with their own session, schedule and audit trail." },
        { icon: "CloudRain", title: "Weather Data", desc: "Cloud, rain, wind, humidity and seeing detectors integrated." },
        { icon: "Video", title: "IP Cameras", desc: "Live dome and all-sky views, with optional recording." },
      ],
    },
    about: {
      kicker: "// ABOUT US",
      title: "ABOUT",
      titleAccent: "US",
      lead:
        "Scopelink was born from a simple idea: operating a remote observatory should be as easy as using one.",
      body:
        "We build software for observatory owners, astronomy associations, universities and telescope hosting providers who need secure remote access, reliable automation and centralized management.",
      story: [
        "Our platform brings together users, devices and observatories in a single place, making it easy to share equipment, manage permissions and monitor operations from anywhere.",
        "Scopelink is backed by more than 25 years of experience in software development and extensive experience designing and operating critical infrastructures, where reliability, security and traceability are essential. Those principles are at the core of everything we build.",
        "Unlike generic remote access solutions, Scopelink is designed specifically for astronomy. It integrates with the hardware and software commonly found in observatories, reducing complexity for owners while providing a seamless experience for users.",
        "Our goal is to make remote observatories easier to operate, easier to share and easier to grow.",
      ],
      publicCta: "Check out observatories with a public profile",
      backHome: "Back home",
      backSection: "View summary section",
      features: [
        { icon: "Shield", title: "Zero-Trust Security", desc: "Encrypted VPN with per-user permissions. Zero shared passwords." },
        { icon: "Cpu", title: "IoT Integration", desc: "Weather stations, cameras, sky sensors, UPS, smart relays and more." },
        { icon: "Cloud", title: "Cloud Access", desc: "Operate from your local network or from anywhere on the planet." },
        { icon: "Users", title: "True Multi-user", desc: "Every member with their own session, schedule and audit trail." },
        { icon: "CloudRain", title: "Weather Data", desc: "Cloud, rain, wind, humidity and seeing detectors integrated." },
        { icon: "Video", title: "IP Cameras", desc: "Live dome and all-sky views, with optional recording." },
      ],
    },
    plans: {
      kicker: "// SUBSCRIPTIONS",
      title: "ONE PLAN FOR",
      titleAccent: "EVERY OBSERVATORY",
      subtitle:
        "Choose your station capacity. Volume discounts available for clubs and associations.",
      billing: "billed annually",
      perUser: "/ mo per user",
      contact: "Contact",
      mostPopular: "RECOMMENDED",
      tiers: [
        {
          id: "albireo",
          code: "// 01",
          name: "Albireo",
          price: "€5.99",
          period: "/ mo · per user",
          billing: "Billed annually",
          tagline: "To get started with remote",
          features: [
            "Secure VPN connection",
            "Live view from 1 camera",
            "1 weather station feed",
            "Max 2 users",
          ],
          popular: false,
        },
        {
          id: "beehive",
          code: "// 02",
          name: "Beehive",
          price: "€8.99",
          period: "/ mo · per user",
          billing: "Billed annually",
          tagline: "For active observatories",
          features: [
            "Secure VPN connection",
            "Live view from 2 cameras",
            "2 weather device feeds",
            "Safety monitor",
          ],
          popular: false,
        },
        {
          id: "hercules",
          code: "// 03",
          name: "Pleiades",
          price: "€11.99",
          period: "/ mo · per user",
          billing: "Billed annually",
          tagline: "For nightly production",
          features: [
            "Secure VPN connection",
            "Shared remote desktop",
            "4 IP cameras",
            "3 weather device feeds",
            "Safety monitor",
            "Audit logs",
          ],
          popular: true,
        },
        {
          id: "pleiades",
          code: "// 04",
          name: "Hercules",
          price: "€59",
          period: "/ mo · full plan",
          billing: "Billed annually",
          tagline:
            "Share your observatory with members, students and customers",
          features: [
            "3 Full Control Operators",
            "Up to 50 Viewer Users",
            "Ad-hoc observing sessions",
            "Observatory dashboard + live cameras",
            "Weather & environmental data",
            "Device control (operators only)",
            "Audit log",
          ],
          limitations: [
            "No VPN or Remote Desktop for viewer users",
          ],
          addon: "+ 1 TB Shared Storage · €20/mo",
          contactNote: "Need more users? Contact us.",
          ctaOverride: "Get Started",
          popular: false,
        },
        {
          id: "virgo",
          code: "// 05",
          name: "Virgo Cluster",
          price: "Custom",
          period: "Contact for pricing",
          billing: "Multi-observatory",
          tagline: "For networks and institutions",
          features: [
            "Multi-observatory",
            "Booking & schedule management",
            "Self-hosted website security",
            "Devices shared across sites",
            "Online payments for users",
            "And much more…",
          ],
          popular: false,
        },
      ],
      discountNote:
        "Volume discounts available. Reach us at info@scopelink.io for clubs, associations and large facilities.",
    },
    cta: {
      kicker: "// NEXT STEP",
      title: "OPEN YOUR DOME",
      titleAccent: "FROM ANYWHERE",
      body:
        "Tell us about your observatory and we'll architect the exact setup — cameras, weather, access and scheduling — with you.",
      ctaPrimary: "Talk to an engineer",
    },
    news: {
      kicker: "// LOG · CAPTAIN'S JOURNAL",
      title: "LATEST",
      titleAccent: "INSIGHTS",
      subtitle:
        "Case studies, platform releases and technical guides for remote observatories.",
      readMore: "Read article",
      viewAll: "View all posts",
      items: [
        {
          id: "n04",
          category: "Experience",
          date: "2026-07-27",
          dateLabel: "JUL 27 · 2026",
          readTime: "4 min",
          title: "What it feels like to operate a real observatory with Scopelink",
          excerpt:
            "A glimpse of a real session from El Hierro: control your telescope beneath some of the darkest skies in the world.",
          image: "https://img.youtube.com/vi/-wLhxg4us4s/hqdefault.jpg",
          imageSrcSet: "https://img.youtube.com/vi/-wLhxg4us4s/hqdefault.jpg 480w, https://img.youtube.com/vi/-wLhxg4us4s/maxresdefault.jpg 1280w",
          href: "/articles/scopelink-experience-el-hierro",
        },
        {
          id: "n01",
          category: "Release",
          date: "2026-05-20",
          dateLabel: "MAY 20 · 2026",
          readTime: "5 min",
          title: "Virgo Cluster: manage several observatories from a single panel",
          excerpt:
            "Introducing our multi-observatory plan: shared scheduling, federated devices and online payments for associations and telescope networks.",
          image:
            "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=640&q=75",
          imageSrcSet:
            "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=360&q=70 360w, https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=640&q=75 640w, https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=960&q=75 960w",
          href: "/articles/virgo-cluster",
        },
        {
          id: "n02",
          category: "Security",
          date: "2026-04-08",
          dateLabel: "APR 08 · 2026",
          readTime: "7 min",
          title: "Privileged Access Management (PAM) for remote observatories",
          excerpt:
            "Why remote observatories are moving past shared passwords and adopting time-bound, privileged, audited access instead.",
          image:
            "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=640&q=75",
          imageSrcSet:
            "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=360&q=70 360w, https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=640&q=75 640w, https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=960&q=75 960w",
          href: "/articles/pam",
        },
        {
          id: "n03",
          category: "Platform",
          date: "2026-09-14",
          dateLabel: "JUN 14 · 2026",
          readTime: "6 min",
          title: "Integrating the observatory ecosystem",
          excerpt:
            "Telescopes, cameras, mounts, weather stations, UPS, sky sensors, Shelly… how Scopelink unifies the whole observatory under one management layer.",
          image:
            "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=640&q=75",
          imageSrcSet:
            "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=360&q=70 360w, https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=640&q=75 640w, https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=960&q=75 960w",
          href: "/articles/ecosystem",
        },
      ],
    },
    footer: {
      tag: "Your IoT platform for end-to-end management of remote astronomical observatories.",
      colQuick: "Quick links",
      quickLinks: [
        { label: "About us", href: "https://www.scopelink.io/about-us/" },
        { label: "IoT Services", href: "https://www.scopelink.io/servicios-iot/" },
        { label: "Contact", href: CONTACT_URL },
      ],
      colLegal: "Legal",
      legalLinks: [
        { label: "Privacy policy", href: "/privacy-policy" },
        { label: "Cookie policy", href: "/cookie-policy" },
      ],
      colContact: "Contact",
      rights: "© 2026 Scopelink.io · All rights reserved.",
    },
  },
};
